import { useNavigate } from "react-router-dom";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import PauseCircleOutlineOutlinedIcon from "@mui/icons-material/PauseCircleOutlineOutlined";
import { Box, Button } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
const ongoingOrders = [
    {
        id: 1,
        thumbnail: "/static/images/placeholder.png",
        serviceName: "Product Description Bundle (20 Items)",
        description:
            "High-quality English & Arabic product descriptions crafted to boost conversions and improve SEO ranking.",
        providerName: "Creative Content Ltd.",
        date: "2025-12-05",
        time: "14:00",
        deliveryDays: 2,
        price: 250,
        status: "Pending",
        paymentStatus: "Paid",
    },
    {
        id: 2,
        thumbnail: "/static/images/placeholder.png",
        serviceName: "Monthly Blog Writing (12 Blogs)",
        description:
            "Professionally researched and SEO-optimized blogs to increase organic traffic and strengthen brand authority.",
        providerName: "BlogMasters",
        date: "2025-12-10",
        time: "10:00",
        deliveryDays: 7,
        price: 850,
        status: "Accepted",
        paymentStatus: "Paid",
    },
    {
        id: 3,
        thumbnail: "/static/images/placeholder.png",
        serviceName: "Social Media Captions Package (40 Captions)",
        description:
            "Creative, engaging captions for Facebook, Instagram & TikTok written to increase engagement and impressions.",
        providerName: "SocialGurus",
        date: "2025-12-07",
        time: "09:30",
        deliveryDays: 3,
        price: 180,
        status: "In Progress",
        paymentStatus: "Pending",
    },
];
const Services = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [isChecked, setIsChecked] = useState(false);

    return (
        <>
            <div className="main_title ai_command_page d_flex">
                <div className="lt">
                    <h1>Services</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Services
                    </p>
                </div>

                <div className="right_s">
                    <p>Kill Switch</p>
                    <SwitchToggle
                        onChange={(e) => setIsChecked(e.target.checked)}
                        label={isChecked ? "On" : "Off"}
                    />
                </div>
            </div>

            <div className="stats_boxes gap_m">
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            24
                            <p>Total Services</p>
                        </h2>
                        <figure className="blue">
                            <BuildOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>
                            18
                            <p>Active Services</p>
                        </h2>
                        <figure className="sucess">
                            <CheckCircleOutlineOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>
                            6
                            <p>Inactive Services</p>
                        </h2>
                        <figure className="warning">
                            <PauseCircleOutlineOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>
            </div>

            <div className="cards mt_20">
                <div className="table_header">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search subscription..."
                            />
                        </Box>
                        <div className="form">
                            <select>
                                <option value="all">All Categories</option>
                                <option value="footwear">Footwear</option>
                                <option value="clothing">Clothing</option>
                                <option value="accessories">Accessories</option>
                            </select>
                            <select>
                                <option value="all">All Status</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                            <div className="control_group">
                                <input type="date" />
                            </div>
                        </div>
                    </div>
                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => navigate("add")}>Add Service</Button>
                    </div>

                </div>
                <div className="book_service">
                    {ongoingOrders.map((order) => (
                        <div className="book_inner" key={order.id}>
                            <figure>
                                <img src={order.thumbnail} alt="icon" />
                            </figure>

                            <h3>{order.serviceName}</h3>
                            <p>{order.description}</p>

                            <p>
                                <b>Provider:</b> {order.providerName}
                            </p>

                            <p>
                                <b>Date:</b> {order.date} &nbsp;|&nbsp; <b>Time:</b> {order.time}
                            </p>

                            <div className="time">
                                <p>{order.deliveryDays} days delivery</p>
                                <h4 className="price">AED {order.price}</h4>
                            </div>




                            <Button
                                className="btn btn_primary sm "
                                onClick={() => navigate("/manage-vendors/view-vendor/view-service")}
                            >
                                View Service
                            </Button>
                        </div>
                    ))}
                </div>
            </div></>
    );
};

export default Services;
